import { useCallback, useEffect, useState } from "react";
import api from "@/services/api";

export interface Course {
  id: string;
  name: string;
}

// Loads the growlearn/admin-managed course list used to populate the qualification
// dropdown. `refetch` lets the Settings page refresh after add/delete.
export function useCourses() {
  const [courses, setCourses] = useState<Course[]>([]);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get("/courses");
      setCourses(res.data.courses || []);
    } catch {
      /* leave existing list on failure */
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refetch(); }, [refetch]);

  return { courses, loading, refetch };
}
